import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import SignupModal from "./SignupModal";
import { Translator } from './translator';

const CountdownTimer = ({ endTime, onExpire, translatedText }) => {
  const [timeLeft, setTimeLeft] = useState("");

  const parseCustomDate = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    if (!isNaN(d)) return d;
    return new Date(dateStr.replace(" ", "T") + "Z");
  };
  

  useEffect(() => {
    const updateTimer = () => {
      if (!endTime) return;

      const end = parseCustomDate(endTime);
      const now = new Date();
      const diff = end - now;

      if (diff <= 0) {
        const daysAgo = Math.floor(Math.abs(diff) / (1000 * 60 * 60 * 24));
        const hoursAgo = Math.floor((Math.abs(diff) % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutesAgo = Math.floor((Math.abs(diff) % (1000 * 60 * 60)) / (1000 * 60));

        setTimeLeft(`scaduto da ${daysAgo}g ${hoursAgo}h ${minutesAgo}min`);
        onExpire?.();
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeLeft(`${days}giorni ${hours}ore ${minutes}min ${seconds}secondi`);
    };

    updateTimer(); // initial run
    const interval = setInterval(updateTimer, 1000); // update every second
    return () => clearInterval(interval);
  }, [endTime]);

if (timeLeft.startsWith("scaduto da")) {
  return (
    <span className="text-red-600 font-semibold text-center text-sm">
      {translatedText.text5}
    </span>
  );
}


  return (
    <div className="w-full text-center">
      <span className="inline-block whitespace-nowrap text-[#49B15D] text-sm px-4 py-1 rounded-md">
        {translatedText.text22} {timeLeft}
      </span>
    </div>
  );
};



const MyTours = () => {
  const [tours, setTours] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user"));
  const [showSignupModal, setShowSignupModal] = useState(false);
  const { translateText, lang } = Translator();


  const baseText = {
    text1: "Tour acquistati",
    text2: "Scopri ogni angolo dei tour che hai scelto",

    durationDay: "giorno",
    durationDay2: "giorni",
    discoverTour: "Scopri il tour",
    text4: "Durata consigliata",
    text5: "Scaduto",
    text6: "Il tour è scaduto e non è più accessibile.",
    text7: "Nessun tour acquistato",

    text22: "Attivo - scade tra:"
  };
  
  const [translatedText, setTranslatedText] = useState(baseText);
  useEffect(() => {
    const translateAll = async () => {
      const entries = Object.entries(baseText);
      const translatedEntries = await Promise.all(
        entries.map(async ([key, value]) => [key, await translateText(value)])
      );
      setTranslatedText(Object.fromEntries(translatedEntries));
    };
  
    translateAll();
  }, [lang]);


  const authUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); }
    catch { return null; }
  }, []);

  useEffect(() => {
    if (!authUser?.email) {
      navigate("/login", {
        replace: true,
        state: { redirect: location.pathname + location.search }
      });
    }
  }, [authUser, navigate, location]);



  const normalizeAccessUntil = (s) => {
    if (!s) return null;
    try {
      // strip nanoseconds to milliseconds → ".621000000" -> ".621"
      const fixed = s.replace(/(\.\d{3})\d+/, "$1");
      const d = new Date(fixed);
      if (!isNaN(d)) return d;
    } catch {}
    return null;
  };


useEffect(() => {
  const fetchTours = async () => {
    try {
      const { data } = await axios.get(
        "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/myPurchasedTours",
        { params: { email: user?.email } }
      );
      console.log("Raw tours payload:", data);

      const toursArray = Array.isArray(data) ? data : [];

      const translatedWithExpiry = await Promise.all(
        toursArray.map(async (tour) => {
          // robust expiry
          const expiryDate = normalizeAccessUntil(tour.accessUntil);
          const isExpired = expiryDate ? (expiryDate < new Date()) : false;

          // translate with guard
          const safeTranslate = async (v) => {
            try { return await translateText(v || ""); } catch { return v || ""; }
          };

          return {
            ...tour,
            // translate what you show
            name: await safeTranslate(tour.name),
            Subheading: await safeTranslate(tour.Subheading),
            Region: await safeTranslate(tour.Region),
            likes: tour.likes ?? 0,
            isExpired,
            expiryDate: expiryDate || new Date(), // fallback so sort doesn't NaN
            type: tour.type || "TECHETOUR",       // ensure defined
          };
        })
      );


      // active first
      // Both active: sort by expiry descending
      // Both expired: sort by expiry ascending
      translatedWithExpiry.sort((a, b) => {
        if (a.isExpired !== b.isExpired) {
          return a.isExpired - b.isExpired;
        }
        if (!a.isExpired) {
          
          return b.expiryDate - a.expiryDate;
        }
        return a.expiryDate - b.expiryDate;
      });

      setTours(translatedWithExpiry);
    } catch (err) {
      console.error("Error fetching tours:", err);
    }
  };

  fetchTours();
}, [translateText, user.email]);







  


const handleLike = async (e, tourId) => {
  e.stopPropagation();
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user || !user.email) {
    setShowSignupModal(true);
    return;
  }

  try {
    const response = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/addRemoveLikeToTour`, {
      params: { tourID: tourId, email: user.email }
    });

    const result = response.data;

    if (result === 1 || result === 0) {
      setTours(prev =>
        prev.map(t => {
          if (t.id === tourId) {
            const updatedLikes = t.likes + (result === 1 ? 1 : -1);
            return { ...t, likes: Math.max(0, updatedLikes) };
          }
          return t;
        })
      );
    }

  } catch (error) {
    console.error("Errore durante il toggle like:", error);
  }
};




  

  






  useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setShowSignupModal(false);
    }
  };

  if (showSignupModal) {
    window.addEventListener("keydown", handleKeyDown);
  }

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [showSignupModal]);







  return (
      <>
    {/* Hero Section */}
    <div className="bg-[#324B8E] w-full h-[380px] flex flex-col justify-center px-16 text-white text-left">
      <h1 className="text-4xl font-bold">{translatedText.text1 || "Tour Digitali"}</h1>
      <h2 className="text-lg mt-2 text-white">{translatedText.text2 || "Sfoglia il catalogo tour"}</h2>
    </div>


    <div className="min-h-screen bg-gray-100 pt-32 pb-10 px-6">
      <div className="flex flex-wrap justify-center gap-6 max-w-7xl mx-auto">
        {tours.length === 0
          ? <p className="text-[#000000] text-center">{translatedText.text7}</p>
          : tours.map(tour => (
          <div
            key={tour.id}
            className={`w-full sm:w-[45%] lg:w-[30%] rounded-xl shadow transition-all duration-200 flex flex-col h-full 
              ${tour.isExpired ? 'bg-gray-900 text-gray-400 cursor-not-allowed opacity-70' : 'bg-white hover:shadow-lg cursor-pointer'}`}

            onClick={() => {
              if (tour.isExpired) {
                alert(translatedText.text6);
                return;
              }
              const isFuori = (tour.type || '').toUpperCase().includes('FUORI')
                || (tour.PrimaryCategory || '').toLowerCase().includes('fuori');
              navigate(isFuori ? `/FuoriRotta/${tour.id}` : `/tour/${tour.id}`);

              /*
              if ((tour.type || "").toUpperCase() === "FUORI") {
                navigate(`/FuoriRotta/${tour.id}`);
              } else {
                navigate(`/tour/${tour.id}`);
              }*/
            }}
          >
            <div className="relative overflow-hidden rounded-t-xl">
              <img
                src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${tour.Image}`}
                alt={tour.name}
                className="h-48 w-full object-cover transform transition-transform duration-300 hover:scale-110"
              />
              
            </div>
            <div className="flex flex-col justify-between flex-grow p-4">
            
            <h2 className="text-lg font-semibold text-black text-center h-[60px] flex items-center justify-center text-ellipsis text-wrap">{tour.name} </h2>
            <h2 className="text-lg font-medium text-black text-center h-[60px] flex items-center justify-center text-ellipsis text-wrap">{tour.Subheading} </h2>

             



<div className="mt-3 mb-3 flex items-center justify-between gap-x-4 -ml-6 flex-nowrap">
  <span className="inline-block text-black text-sm px-6 py-1 rounded-md">
    {tour.Region}
  </span>

  <span className="inline-block text-[#324B8E] border border-[#324B8E] text-sm px-2 py-1 ml-4 rounded-md">
    {tour.PrimaryCategory}
  </span>
</div>






<CountdownTimer endTime={tour.accessUntil} translatedText={translatedText} />







      
              
            </div>
          </div>
        ))}
      </div>
      
      {showSignupModal && (
        <SignupModal onClose={() => setShowSignupModal(false)} />
        )}
    </div>
  </>
  );
};

export default MyTours;
